import React from 'react';
import Field, { TextInput, TextArea } from '../../../components/ui/Field';
import { EXTERNAL_MEANING } from '../../../utils/agentReadiness';

export const WHERE_OPTIONS = [
  { key: 'platform', title: 'Aquí, en la plataforma', text: 'Le das clave, instrucciones y canales desde esta pantalla, y responde el motor nuevo.' },
  { key: 'n8n', title: 'Externo: en n8n', text: 'Funciona en un flujo de n8n. Aquí solo queda registrado.' },
  { key: 'web', title: 'Externo: en una página web', text: 'Funciona en el sitio del cliente o en otra plataforma web. Aquí solo queda registrado.' },
  { key: 'other', title: 'Externo: en otro sistema', text: 'Cualquier otro servicio. Aquí solo queda registrado.' },
];

// Elegir dónde funciona el agente. Para los externos, una dirección y una nota opcionales para el equipo.
export default function WhereItLives({ value, onChange, url, onUrl, note, onNote, urlError, hidePlatform = false }) {
  const options = hidePlatform ? WHERE_OPTIONS.filter((o) => o.key !== 'platform') : WHERE_OPTIONS;
  const external = value !== 'platform';
  return (
    <fieldset className="space-y-3">
      <legend className="text-[13px] font-medium text-fg mb-1.5">¿Dónde funciona?</legend>
      <div role="radiogroup" className="grid gap-2">
        {options.map((o) => (
          <label key={o.key} className={`flex items-start gap-3 rounded-lg border p-3 cursor-pointer transition-colors
            ${value === o.key ? 'border-live/50 bg-live-soft' : 'border-line hover:border-fg/15'}`}>
            <input type="radio" name="managed_by" value={o.key} checked={value === o.key} onChange={() => onChange(o.key)}
              className="mt-0.5 accent-[rgb(var(--live))] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-live/60" />
            <span>
              <span className="block text-sm font-medium text-fg">{o.title}</span>
              <span className="block text-[12.5px] text-fg-dim mt-0.5">{o.text}</span>
            </span>
          </label>
        ))}
      </div>
      {external && (
        <div className="space-y-3 pt-1">
          <p className="text-[12.5px] leading-relaxed text-fg-faint">{EXTERNAL_MEANING}</p>
          <Field label="Dónde está" optional error={urlError} hint="El enlace al flujo de n8n o a la página donde vive.">
            <TextInput value={url} onChange={(e) => onUrl(e.target.value)} placeholder="https://…" inputMode="url" spellCheck={false} />
          </Field>
          <Field label="Nota para el equipo" optional>
            <TextArea rows={2} value={note} onChange={(e) => onNote(e.target.value)} maxLength={500} placeholder="Quién lo mantiene, qué hace, etc." />
          </Field>
        </div>
      )}
    </fieldset>
  );
}

export const validUrl = (u) => !u.trim() || /^https?:\/\/\S+$/i.test(u.trim());
